module.exports = require("./dist/slick.js");


//////////////////
// WEBPACK FOOTER
// angular-slick (bower component)
// module id = 505
// module chunks = 0